// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"LoginForm__wrapper","fields":"LoginForm__fields","login":"LoginForm__login"};